import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import Loader from '../common/Loader';
import ModalPopup from '../common/Modal';
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import crossIcon from "../../assets/Icons/cross.svg";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';



const Statement = () => {
    const [openMenuIndex, setOpenMenuIndex] = useState(false);
    const [data, setData] = useState({
        text: ""
    });
    const location = useLocation()
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const menuRefs = useRef([]);
    const [refresh, setRefresh] = useState(false);
    const permissions = useSelector(isPermission);
    const [modalswitch, setmodalswitch] = useState(false);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const addPermission = role == "schooladmin";


    const toggleMenu = () => {
        setOpenMenuIndex(true);
    };


    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.school_statement_show).then((res) => {
            if (res.status === 200) {
                setData(res.data);
            } else {

                dispatch(message(res.message));
            }
        });
        setLoader(false)
    }


    const handleSubmit = (e) => {
        e.preventDefault()
        if (!data.text?.trim()) {
            return dispatch(message("Empty Statement Not Accepted"))
        }

        let form = new FormData()
        form.append("text", data?.text)
        form.append("id", data._id)
        setLoader(false)
        Postdata(HttpService.school_statement_add, form).then((res) => {
            if (res.status == 200) {
                navigate("/settings", {
                    state: { currentTab: "Statements" },
                    replace: true,
                });
            } else {

                dispatch(message(res.message))
            }
            setmodalswitch(false)
            setOpenMenuIndex(false)
            setLoader(false)
            setRefresh(!refresh)
        })

    }
    useEffect(() => {
        fetchData();

    }, [refresh])
    useEffect(() => {
        // Navigate to /settings with currentTab only once
        if (location?.state?.currentTab !== "Statements") {
            navigate("/settings", {
                state: { currentTab: "Statements" },
                replace: true,
            });
        }
    }, []);



    // Close menu on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedInside = false;
            menuRefs.current.forEach(ref => {
                if (ref && ref.contains(event.target)) {
                    clickedInside = true;
                }
            });
            if (!clickedInside) {
                setOpenMenuIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    if (loader) {
        return <Loader isClass="loader_fullscreen" />
    }
    return (
        <div className=" rounded-lg p-6  relative text-gray-800   mx-auto">
            <ModalPopup
                className="alert-box-popup"
                show={modalswitch}
                size="lg"
                onHide={() => { setmodalswitch(false); setRefresh(!refresh) }}
                heading="Are you sure?"
            >
                <div className="text-start flex justify-center flex-col items-center gap-3 px-3 relative ">
                    <img
                        src={crossIcon}
                        alt=""
                        className="absolute top-2 right-2 cursor-pointer"
                        onClick={() => {
                            setmodalswitch(false);
                            setRefresh(!refresh)
                        }}
                    />
                    <h3>Edit Statement</h3>

                    <form className="w-full" onSubmit={handleSubmit}>
                        <div className="w-full  gap-3 mb-2 mt-4">
                            <div className="w-full mb-2">
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={data.text}
                                    config={{
                                        placeholder: "Write Here"
                                    }}
                                    onChange={(event, editor) => {
                                        setData({ ...data, text: editor.getData() });
                                    }}
                                />
                                {!data.text?.trim() && <span className="text-red-600">Required</span>}
                            </div>
                            <button
                                type="submit"
                                className="button-field-primary "
                                style={{ width: "100%" }}
                            >
                                {loader ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </form>

                </div>
            </ModalPopup>
            <div>
                <h2 className="text-2xl font-semibold mb-2">
                    Statements
                </h2>

                <div>
                    {/* <h3 className="font-normal mb-1 text-lg">{data?.text}</h3> */}

                    <div dangerouslySetInnerHTML={{ __html: data.text }} />

                </div>
            </div>
            <div className=' '>
                <div className="absolute top-3 right-3">
                    <button onClick={() => toggleMenu()}>
                        <img
                            src={HiOutlineDotsVertical}
                            className="text-black-500 hover:text-black"
                        />
                    </button>

                    {openMenuIndex && (
                        <div ref={(el) => (menuRefs.current[0] = el)} className="absolute right-0 w-20 bg-white  border rounded-xl z-10">
                            {addPermission && <button
                                className="block w-full text-left px-3 rounded-xl py-2 text-sm hover:bg-gray-100"
                                // onClick={() => navigate(`/education/performance/edit/${data._id}`, { state: { type: "edit" } })}
                                onClick={() => setmodalswitch(true)}
                            >
                                Edit
                            </button>}

                        </div>
                    )}
                </div>

            </div>

        </div>
    )
}

export default Statement
